module.exports = __webpack_public_path__ + "static/media/1008882.8dca7f20.png";